import { Component, ContentChildren, QueryList } from "@angular/core";
import { DsTextAccordionItemComponent } from "../ds-text-accordion-item/ds-text-accordion-item.component";

@Component({
  selector: "ds-text-accordion",
  templateUrl: "./ds-text-accordion.component.html",
  styleUrls: ["./ds-text-accordion.component.scss"],
})
export class DsTextAccordionComponent {
  @ContentChildren(DsTextAccordionItemComponent)
  items!: QueryList<DsTextAccordionItemComponent>;

  constructor() {}

  ngAfterContentInit() {
    this.items.forEach((item) => {
      item.opened.subscribe((openedItem) => {
        this.closeOthers(openedItem);
      });
    });
  }

  private closeOthers(openItem: DsTextAccordionItemComponent) {
    this.items.forEach((item) => {
      if (item !== openItem) {
        item.close();
      }
    });
  }
}
